import { Navigate } from 'react-router-dom'

import { buildAppMode } from '@/shared/buildMode'

export function RootRedirect() {
  const target = buildAppMode === 'warehouse_delman' ? '/delman' : '/warehouse'
  return <Navigate to={target} replace />
}
